import logo from '../../assets/brand/nerds-at-play.png';
import './landing.css';
const gameUrl = 'https://play.nerdsatplay.org/';
export function LandingPage() {
  return (
    <div className="landing">
      <header className="landing-header">
        <a className="landing-brand" href="/" aria-label="Nerds at Play home">
          <img src={logo} alt="" width="48" height="48" />
          <span>
            Nerds at Play<small>The world is what you make it.</small>
          </span>
        </a>
        <nav aria-label="Main navigation">
          <a href="#how-it-works">How it works</a>
          <a className="landing-enter" href={gameUrl}>
            Enter the game <span aria-hidden="true">↗</span>
          </a>
        </nav>
      </header>
      <main>
        <section className="landing-hero" aria-labelledby="landing-title">
          <p className="landing-eyebrow">An in-person game of possible AI futures</p>
          <h1 id="landing-title">
            The future isn’t written.
            <br />
            <em>Take a seat at the table.</em>
          </h1>
          <p className="landing-intro">
            Build an organization. Make your case. Find your allies.
            <br className="landing-wide" /> Then discover what happens when everyone’s plans meet
            the world.
          </p>
          <div className="landing-actions">
            <a className="landing-primary" href={gameUrl}>
              Enter the game <span aria-hidden="true">↗</span>
            </a>
            <a href="#how-it-works">
              See how a round unfolds <span aria-hidden="true">↓</span>
            </a>
          </div>
          <p className="landing-caption">
            Play together in the room. Follow the consequences on the board.
          </p>
        </section>
        <section className="landing-premise" aria-labelledby="premise-title">
          <p className="landing-eyebrow">The deployment dilemma</p>
          <h2 id="premise-title">
            Faster services. Exposed records.
            <br />A city with a decision to make.
          </h2>
          <p>
            It’s 2028. AI promises to transform public services, but an early deployment has exposed
            sensitive information. Residents want opportunity and accountability. Your organization
            has a vision for what comes next—and limited power to make it happen.
          </p>
        </section>
        <section className="landing-story" id="how-it-works" aria-labelledby="story-title">
          <div className="landing-section-heading">
            <p className="landing-eyebrow">Different ambitions. One shared world.</p>
            <h2 id="story-title">A round at the table</h2>
            <p>An illustrative round. Your choices will write a different story.</p>
          </div>
          <div className="landing-orgs" aria-label="Example organizations">
            <span>
              <i className="landing-dot civic" />
              Civic Trust
            </span>
            <span>
              <i className="landing-dot lab" />
              An AI research lab
            </span>
            <span>
              <i className="landing-dot city" />
              City government
            </span>
          </div>
          <ol className="landing-timeline">
            <li className="landing-step foundation">
              <div className="landing-stage">
                <span>01 · Foundation</span>
              </div>
              <article className="landing-story-card civic">
                <p className="landing-card-label">Decide what you stand for</p>
                <h3>“People need a say in the systems that affect them.”</h3>
                <p>
                  Create an organization and its desired future. The Game Master assigns resources,
                  capabilities, constraints, and private intelligence.
                </p>
              </article>
            </li>
            <li className="landing-step planning">
              <div className="landing-stage">
                <span>02 · Plan &amp; negotiate</span>
              </div>
              <article className="landing-story-card lab">
                <p className="landing-card-label">Make a move together</p>
                <h3>Ask for an audit. Offer a pilot. Build a coalition.</h3>
                <p>
                  Talk with other teams. Choose what your organization will work toward and submit
                  an Action Brief. Your own chatbot can help you think it through.
                </p>
                <p className="landing-private">
                  Your plans and private intelligence stay with your team and the GM.
                </p>
              </article>
            </li>
            <li className="landing-step consequence">
              <div className="landing-stage">
                <span>03 · World Broadcast</span>
              </div>
              <article className="landing-story-card city">
                <p className="landing-card-label">The world responds</p>
                <h3>“The rollout pauses. An unlikely partnership forms.”</h3>
                <p>
                  The GM considers everyone’s plans, uses AI to help assess consequences, and
                  approves the next world update. Events may help your causes, hurt them, or leave
                  them untouched.
                </p>
              </article>
            </li>
            <li className="landing-step reflection">
              <div className="landing-stage">
                <span>04 · Adapt &amp; reflect</span>
              </div>
              <article className="landing-story-card reflect">
                <p className="landing-card-label">Your next choice starts here</p>
                <h3>What changed—and what will you do about it?</h3>
                <p>
                  Respond to new information over up to three rounds. Finish by comparing the world
                  you created with the future you wanted.
                </p>
              </article>
            </li>
          </ol>
        </section>
        <section className="landing-invitation" aria-labelledby="invitation-title">
          <p className="landing-eyebrow">Curiosity beats certainty</p>
          <h2 id="invitation-title">
            No single winner.
            <br />
            Plenty to talk about.
          </h2>
          <p>
            This is a social game about choices, tradeoffs, and possible futures—not a prediction.
            Bring your perspective. You don’t need to be an AI expert.
          </p>
          <a className="landing-primary" href={gameUrl}>
            Join your team <span aria-hidden="true">↗</span>
          </a>
          <p className="landing-caption">
            Joining an event? Enter the game to request a team or sign in.
            <br />
            The Game Master approves new teams.
          </p>
        </section>
      </main>
      <footer className="landing-footer">
        <span>Nerds at Play</span>
        <p>The game happens around the table. The board remembers the story.</p>
        <a href={gameUrl}>Team &amp; GM login ↗</a>
      </footer>
    </div>
  );
}
